export const ROLE_SUPERADMIN = "ROLE_SUPERADMIN";
export const ROLE_SUPERADMINREAD = "ROLE_SUPERADMINREAD";
export const Admin = "Admin";
export const ROLE_USER = "ROLE_USER";
export const ROLE_TENANTADMIN = "ROLE_TENANTADMIN";
export const ROLE_TENANTREAD = "ROLE_TENANTREAD";
export const ROLE_SECURITY_ENGINEER = "Security Engineer";

export const defaultRoles: string[] = [
  "ROLE_SUPERADMIN",
  "ROLE_SUPERADMINREAD",
  "Admin",
  "ROLE_USER",
  "ROLE_TENANTADMIN",
  "ROLE_TENANTREAD",
  "Read Only",
];

export const defaultRolesDisplayName = {
  ROLE_SUPERADMIN: "Super Admin",
  ROLE_SUPERADMINREAD: "Super Admin(Read)",
  Admin: "Admin",
  ROLE_USER: "User",
  ROLE_TENANTADMIN: "Account Admin",
  ROLE_TENANTREAD: "Account Read",
  "Read Only": "Read Only",
};

export const PermissionSetMap = {
  WRITE_PRODUCT: "PRODUCT.CREATE_PRODUCT",
  UPDATE_PRODUCT: "PRODUCT.UPDATE_PRODUCT",
  DELETE_PRODUCT: "PRODUCT.DELETE_PRODUCT",
  WRITE_SUB_PRODUCT: "SUB_PRODUCT.CREATE_SUB_PRODUCT",
  UPDATE_SUB_PRODUCT: "SUB_PRODUCT.UPDATE_SUB_PRODUCT",
  DELETE_SUB_PRODUCT: "SUB_PRODUCT.DELETE_SUB_PRODUCT",
  WRITE_PROJECT: "PROJECT.CREATE_PROJECT",
  UPDATE_PROJECT: "PROJECT.UPDATE_PROJECT",
  DELETE_PROJECT: "PROJECT.DELETE_PROJECT",
  EDIT_TOOL_CONFIG: "TOOLS.UPDATE_TOOLS",
  WRITE_TOOLS: "TOOLS.CREATE_TOOLS",
  DELETE_TOOL: "TOOLS.DELETE_TOOLS",
  UPDATE_POLICY: "COMPLIANCE_POLICY.UPDATE_POLICY",
  WRITE_POLICY: "COMPLIANCE_POLICY.CREATE_POLICY",
  DELETE_POLICY: "COMPLIANCE_POLICY.DELETE_POLICY",
  READ_POLICY: "COMPLIANCE_POLICY.READ_POLICY",
  CREATE_REPORT: "COMPLIANCE.CREATE_REPORT",
  UPDATE_REPORT: "COMPLIANCE.UPDATE_REPORT",
  UPDATE_FINDINGS: "FINDINGS.UPDATE_FINDINGS",
  WRITE_FINDINGS: "FINDINGS.CREATE_FINDINGS",
  EDIT_CUSTOM_FIELDS: "FINDINGS.EDIT_CUSTOM_FIELDS",
  ASSIGN_OWNER: "FINDINGS.ASSIGN_OWNER",
  MARK_ACCEPT_RISK: "FINDINGS.MARK_ACCEPT_RISK",
  MARK_SUPPRESSED: "FINDINGS.MARK_SUPPRESSED",
  MARK_TRIAGE: "FINDINGS.MARK_TRIAGE",
  MARK_IN_PROGRESS: "FINDINGS.MARK_IN_PROGRESS",
  MARK_CONTROLLED: "FINDINGS.MARK_CONTROLLED",
  SIMILAR_FINDINGS_SUPPRESSED:
    "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_SUPPRESSED",
  MARK_CONFIRM: "FINDINGS.MARK_CONFIRM",
  MARK_FALSE_POSITIVE: "FINDINGS.MARK_FALSE_POSITIVE",
  MARK_REOPEN: "FINDINGS.MARK_REOPEN",
  MARK_MITIGATED: "FINDINGS.MARK_MITIGATED",
  UPDATE_CATEGORY: "FINDINGS.UPDATE_CATEGORY",
  UPDATE_SEVERITY: "FINDINGS.UPDATE_SEVERITY",
  UPDATE_FINDING_TAGS: "FINDINGS.UPDATE_FINDING_TAGS",
  FINDINGS_UPDATE_BASIC_DETAILS: "FINDINGS.UPDATE_BASIC_DETAILS",
  UPDATE_FINDINGS_PROJECT: "FINDINGS.UPDATE_FINDINGS_PROJECT",
  FINDINGS_CHANGE_DUE_DATE: "FINDINGS.CHANGE_DUE_DATE",
  CREATE_TICKETS: "TICKETS.CREATE_TICKETS",
  DELETE_TICKETS: "TICKETS.DELETE_TICKETS",
  UPDATE_ALERTS: "ALERTS.UPDATE_ALERT",
  UPDATE_KNOWLEDGE_BASE: "KNOWLEDGE_BASE.UPDATE_KNOWLEDGE_BASE",
  CREATE_KNOWLEDGE_BASE: "KNOWLEDGE_BASE.CREATE_KNOWLEDGE_BASE",
  CREATE_USER: "USER_MANAGEMENT.CREATE_USER",
  UPDATE_USER: "USER_MANAGEMENT.UPDATE_USER",
  DELETE_USER: "USER_MANAGEMENT.DELETE_USER",
  CREATE_ROLE: "USER_MANAGEMENT.CREATE_ROLE",
  UPDATE_ROLE: "USER_MANAGEMENT.UPDATE_ROLE",
  DELETE_ROLE: "USER_MANAGEMENT.DELETE_ROLE",
  CREATE_SLA: "TOOL_SETTINGS.CREATE_TOOL_SETTING",
  DELETE_SLA: "TOOL_SETTINGS.DELETE_TOOL_SETTING",
  UPDATE_SLA: "TOOL_SETTINGS.UPDATE_TOOL_SETTING",
  UPDATE_GLOBAL_SETTING: "GLOBAL_SETTINGS.UPDATE_GLOBAL_SETTING",
  SIMILAR_FINDINGS_REOPEN: "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_REOPEN",
  SIMILAR_FINDINGS_ACCEPT_RISK:
    "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_ACCEPT_RISK",
  SIMILAR_FINDINGS_CATEGORY:
    "SIMILAR_FINDINGS.UPDATE_SIMILAR_FINDINGS_CATEGORY",
  SIMILAR_FINDINGS_FALSEPOSITIVE:
    "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_FALSE_POSITIVE",
  SIMILAR_FINDINGS_CONFIRM: "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_CONFIRM",
  SIMILAR_FINDINGS_SEVERITY:
    "SIMILAR_FINDINGS.UPDATE_SIMILAR_FINDINGS_SEVERITY",
  SIMILAR_FINDINGS_RULE_UPDATE: "SIMILAR_FINDINGS.SIMILAR_FINDINGS_RULE_UPDATE",
  SIMILAR_FINDINGS_CONTROLLED:
    "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_CONTROLLED",
  SIMILAR_FINDINGS_IN_PROGRESS:
    "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_IN_PROGRESS",
  SIMILAR_FINDINGS_TRIAGE: "SIMILAR_FINDINGS.MARK_SIMILAR_FINDINGS_TRIAGE",
  CREATE_RUN_BOOK: "RUNBOOK.CREATE_RUNBOOK",
  DELETE_RUN_BOOK: "RUNBOOK.DELETE_RUNBOOK",
  UPDATE_RUN_BOOK: "RUNBOOK.UPDATE_RUNBOOK",
  TRIGGER_RUNBOOK: "RUNBOOK.TRIGGER_RUNBOOK",
  CREATE_TEAMS: "TEAMS.CREATE_TEAMS",
  UPDATE_TEAMS: "TEAMS.UPDATE_TEAMS",
  DELETE_TEAMS: "TEAMS.DELETE_TEAMS",
  CI_JOB_UPDATE: "CI_JOB_CONFIG.UPDATE_CONFIG",
  CI_JOB_DELETE: "CI_JOB_CONFIG.DELETE_CONFIG",
  CI_JOB_ADD: "CI_JOB_CONFIG.ADD_CONFIG",
  ADD_DOMAIN: "DOMAIN.ADD_DOMAIN",
  DELETE_DOMAIN: "DOMAIN.DELETE_DOMAIN",
  UPDATE_SUB_DOMAIN: "DOMAIN.UPDATE_SUB_DOMAIN",
  NOTIFICATION_CREATE: "NOTIFICATION_REPORT.CREATE_NOTIFICATION_REPORT",
  NOTIFICATION_UPDATE: "NOTIFICATION_REPORT.UPDATE_NOTIFICATION_REPORT",
  NOTIFICATION_DELETE: "NOTIFICATION_REPORT.DELETE_NOTIFICATION_REPORT",
  EXTERNAL_USER_SYNC: "EXTERNAL_USER_SYNC.SYNC_USERS",
  EXTERNAL_USER_ADD_CONFIG: "EXTERNAL_USER_SYNC.ADD_CONFIG",
  EXTERNAL_USER_ADD_ROLE_MAPPING: "EXTERNAL_USER_SYNC.ADD_ROLE_MAPPING",
  EXTERNAL_USER_ADD_TEAM_MAPPING: "EXTERNAL_USER_SYNC.ADD_TEAM_MAPPING",
  EXTERNAL_USER_UPDATE_CONFIG: "EXTERNAL_USER_SYNC.UPDATE_CONFIG",
  PROPOSE: "FINDINGS.PROPOSE",
  TAKE_ACTION_ON_PROPOSAL: "FINDINGS.TAKE_ACTION_ON_PROPOSAL",
  CREATE_BUSINESS_UNIT: "BUSINESS_UNIT.CREATE_BUSINESS_UNIT",
  UPDATE_BUSINESS_UNIT: "BUSINESS_UNIT.UPDATE_BUSINESS_UNIT",
  DELETE_SCAN: "SCAN.DELETE_SCAN",
  UPLOAD_SCAN: "SCAN.UPLOAD_SCAN",
  GET_ARMOR_CODE_AGENT: "ARMORCODE_AGENT.GET_AGENT_LIST",
  CREATE_EXCEPTION: "RISK_REGISTER.CREATE_RISK_REGISTER",
  UPDATE_EXCEPTION: "RISK_REGISTER.UPDATE_RISK_REGISTER",
  DELETE_EXCEPTION: "RISK_REGISTER.DELETE_RISK_REGISTER",
  MODIFY_APPROVERS_LIST: "RISK_REGISTER.MODIFY_APPROVERS_LIST",
  ACCEPTREJECT_EXCEPTION: "RISK_REGISTER.APPROVE_RISK_REGISTER",
  GET_ASSIGNMENT_GROUPS: "TICKETS.GET_ASSIGNMENT_GROUPS",
  UPDATE_FINDINGS_RISK_REGISTER: "FINDINGS.UPDATE_FINDINGS_RISK_REGISTER",
  READ_ALERT: "ALERTS.READ_ALERT",
  READ_AUDIT_LOG: "AUDIT_LOG.READ_AUDIT_LOG",
  READ_REPORT: "COMPLIANCE.READ_REPORT",
  READ_PROJECT: "PROJECT.READ_PROJECT",
  READ_RUNBOOK: "RUNBOOK.READ_RUNBOOK",
  READ_SCAN: "SCAN.READ_SCAN",
  READ_TICKETS: "TICKETS.READ_TICKETS",
  READ_TOOLS: "TOOLS.READ_TOOLS",
  READ_TOOL_SETTINGS: "TOOL_SETTINGS.READ_TOOL_SETTING",
  READ_GLOBAL_SETTINGS: "GLOBAL_SETTINGS.READ_GLOBAL_SETTING",
  READ_USER_MANAGEMENT: "USER_MANAGEMENT.READ_USER_MANAGEMENT",
  READ_RISK_REGISTER: "RISK_REGISTER.READ_RISK_REGISTER",
  CREATE_DASHBOARD: "DASHBOARD.CREATE_DASHBOARD",
  SHARE_PUBLIC_DASHBOARD: "DASHBOARD.SHARE_PUBLIC_DASHBOARD",
  LIMITED_SHARE_DASHBOARD: "DASHBOARD.LIMITED_SHARE_DASHBOARD",
  CREATE_SAVED_SEARCH: "SAVED_SEARCH.CREATE_SAVED_SEARCH",
  SHARE_PUBLIC_SAVED_SEARCH: "SAVED_SEARCH.SHARE_PUBLIC_SAVED_SEARCH",
  CREATE_ASSESSMENTS: "ASSESSMENTS.CREATE_ASSESSMENTS",
  DELETE_ASSESSMENTS: "ASSESSMENTS.DELETE_ASSESSMENTS",
  READ_ASSESSMENTS: "ASSESSMENTS.READ_ASSESSMENTS",
  UPDATE_ASSESSMENTS: "ASSESSMENTS.UPDATE_ASSESSMENTS",
  ADD_ASSESSMENT_FINDING: "ASSESSMENTS.ADD_DRAFT_FINDING",
  UPDATE_ASSESSMENT_FINDING: "ASSESSMENTS.UPDATE_DRAFT_FINDING",
  DELETE_ASSESSMENT_FINDING: "ASSESSMENTS.DELETE_DRAFT_FINDING",
  READ_ASSESSMENT_FINDING: "ASSESSMENTS.READ_DRAFT_FINDING",
  MANAGE_FINDING_TEMPLATES: "ASSESSMENTS.MANAGE_TEMPLATE",
  FINDING_READ_DETAILS: "FINDINGS.READ_DETAILS",
  EXCEPTION_APPROVER: "EXCEPTION_APPROVER.EXCEPTION_APPROVER",
  READ_ASSETS: "ASSETS.READ_ASSETS",
  UPDATE_ASSETS: "ASSETS.UPDATE_ASSETS",
  UPDATE_FINDINGS_ASSESSMENT: "FINDINGS.UPDATE_FINDINGS_ASSESSMENT",
  ASK_ANYA: "ANYA.ASK_ANYA",
  VIEW_ANYA_AGENTS: "ANYA.VIEW_ANYA_AGENTS",
  CREATE_ANYA_AGENTS: "ANYA.CREATE_ANYA_AGENTS",
  UPDATE_ANYA_AGENTS: "ANYA.UPDATE_ANYA_AGENTS",
  DELETE_ANYA_AGENTS: "ANYA.DELETE_ANYA_AGENTS",
  VIEW_SUPPLY_CHAIN: "SUPPLY_CHAIN.VIEW_SUPPLY_CHAIN",
  EDIT_COMPONENTS: "SUPPLY_CHAIN.EDIT_COMPONENTS",
  READ_AI_INVENTORY: "AI_EXPOSURE_MANAGEMENT.READ_AI_INVENTORY",
  WRITE_AI_INVENTORY: "AI_EXPOSURE_MANAGEMENT.WRITE_AI_INVENTORY",
} as const;

interface DashboardOption {
  name: string;
  id: string;
}

export const DEFAULT_DASHBOARDS_OPTIONS: DashboardOption[] = [
  {
    name: "Security (Legacy)",
    id: "SECURITY",
  },
  {
    name: "Developer (Legacy)",
    id: "DEVELOPER",
  },
  {
    name: "CTO (Legacy)",
    id: "CTO",
  },
  {
    name: "CISO (Legacy)",
    id: "CISO",
  },
  {
    name: "SSDLC Healthcheck",
    id: "SSDLC_HEALTHCHECK",
  },
  {
    name: "Teams Summary",
    id: "TEAMS_SUMMARY",
  },
];

export const PRODUCT_ACTION_PERMISSION_MAP = {
  ARCHIVE: PermissionSetMap.UPDATE_PRODUCT,
  DELETE: PermissionSetMap.DELETE_PRODUCT,
  MOVE: PermissionSetMap.UPDATE_PRODUCT,
  VERSION: PermissionSetMap.WRITE_PRODUCT,
  CVSS_MODIFIER: PermissionSetMap.UPDATE_PRODUCT,
  IMPORT_CSV: PermissionSetMap.WRITE_PRODUCT,
  UPDATE_CSV: PermissionSetMap.UPDATE_PRODUCT,
} as const;

export const SUBPRODUCT_ACTION_PERMISSION_MAP = {
  ARCHIVE: PermissionSetMap.UPDATE_SUB_PRODUCT,
  DELETE: PermissionSetMap.DELETE_SUB_PRODUCT,
  MOVE: PermissionSetMap.UPDATE_SUB_PRODUCT,
  VERSION: PermissionSetMap.WRITE_SUB_PRODUCT,
  CVSS_MODIFIER: PermissionSetMap.UPDATE_SUB_PRODUCT,
  IMPORT_CSV: PermissionSetMap.WRITE_SUB_PRODUCT,
  UPDATE_CSV: PermissionSetMap.UPDATE_SUB_PRODUCT,
} as const;
